export { default } from './AfegeixALaLlista';
